import { useCallback, useState } from "react";

import { storageGet, storageSet } from "../lib/storage";

export type Units = "us" | "si";

const STORAGE_KEY = "tc.units";
const DEFAULT_UNITS: Units = "us";

export function useUnits() {
  const [units, setUnitsState] = useState<Units>(() =>
    storageGet<Units>(STORAGE_KEY, DEFAULT_UNITS),
  );

  const setUnits = useCallback((u: Units) => {
    storageSet(STORAGE_KEY, u);
    setUnitsState(u);
  }, []);

  return { units, setUnits };
}
